import axios from 'axios'
import { setInterceptors } from './interceptor'
import {WEB_METHODS} from '@/enum/enum'
import store from "@/store";

const ERROR_STATUS = [404, 500]
const ERROR_TYPE_CODE = '0002'

const IN_ROOT = '/apis'
const IN_VERSION = '/v1'
const ROOT = '/dms'
const VERSION = '/v1'
const USER = '/user'

const COMMON = '/common'

const FILE = '/files'

const VUE_APP_API_BASE_URL = 'http://localhost:8080'
const VUE_APP_API_BASE_DEV_URL = 'https://dms-gw.happymint.dev'
const VUE_APP_API_BASE_PRD_URL = 'https://gw.happymint.kr'

const COMMON_ROOT = `${ROOT + VERSION + COMMON}`
const USER_ROOT = `${ROOT + VERSION + USER}`
const INNER_ROOT = `${IN_ROOT + IN_VERSION}`

const FILE_ROOT_URL = `${FILE + VERSION}`

let loc = window.location.host
/* 23.10.04 로컬인지 아닌지에 따라 URL 설정해줌 */
function createdDefaultAxiosService () {
  const axiosService = axios.create({
    baseURL: loc.includes('localhost') ? `http://localhost:8181/user` : `${window.location.protocol}/user`,
    headers: {
      'X-Requested-With': 'XMLHttpRequest'
    }
  })
  return axiosService
}

let baseURL = ''
if (loc.includes('localhost')) baseURL = `${VUE_APP_API_BASE_URL}`
// if (loc.includes('localhost')) baseURL = `${VUE_APP_API_BASE_DEV_URL}`
else if (loc.includes('happymint.dev')) baseURL = `${VUE_APP_API_BASE_DEV_URL}`
else if (loc.includes('happymint.kr')) baseURL = `${VUE_APP_API_BASE_PRD_URL}`

// 토큰을 사용
function createAxiosAuthService () {
  const axiosService = axios.create({
    baseURL: baseURL
  })

  return setInterceptors(axiosService)
}

const axiosDefaultService = createdDefaultAxiosService()

async function transmission (isToken, method, url, payload, headers) {
  let service = isToken ? createAxiosAuthService() : axiosDefaultService

  if (method === WEB_METHODS.GET) return sendGet(service, url, payload, headers)
  else if (method === WEB_METHODS.POST) return sendPost(service, url, payload, headers)
  else if (method === WEB_METHODS.PUT) return sendPut(service, url, payload)
  else if (method === WEB_METHODS.DELETE) return sendDelete(service, url, payload)

  return null
}

async function sendGet (service, url, payload, headers) {
  let key = null
  let params = null
  if (payload != null) {
    key = payload.key
    params = payload.params
  }

  let lastChar = url.slice(-1)
  url = lastChar === '/' ? url + '?' : url + '?'

  if (Array.isArray(params)) {
    for (let param of params) {
      if (Object.values(param)[0] !== null) {
        let tempString = Object.keys(param) + '=' + Object.values(param) + '&'
        url = url + tempString
      }
    }
  }
  url = url.slice(0, -1)

  if (key !== null && key !== '') {
    const names = Object.keys(key)
    const values = Object.values(key)
    names.forEach((name, index) => {
      url = url.replace('{' + name + '}', values[index])
    })
  }

  return new Promise(resolve => {
    service.get(url, params, headers)
      .then(response => {
        //TODO.
        //if (!response.data.success) {
        //  store.commit('setGlobalErrorStatus', response.data.code)
        //}
        resolve(response.data)
      })
      .catch(async error => {
        if (ERROR_STATUS.includes(error.response.status)) {
          await createErrorTrackHistory(url, error.message, error.response.status)
          store.commit('setGlobalErrorStatus', error.response.status)
          resolve(error)
        }
      })
  })
}

async function sendPost (service, url, payload, headers) {
  let key = null
  let params = null
  if (payload != null) {
    key = payload.key
    params = payload.params
  }

  // object 검사
  if (typeof params !== 'object') {
    return false
  }

  let header = {
    'Content-Type': 'application/json'
  }
  // TODO header -> multipart/form-data ?
  if (headers !== null && header !== '') {
    header = headers
  }

  if (key !== null && key !== '') {
    const names = Object.keys(key)
    const values = Object.values(key)
    names.forEach((name, index) => {
      url = url.replace('{' + name + '}', values[index])
    })
  }

  return new Promise(resolve => {
    service.post(url, params, {
      headers: header
    })
      .then(response => {
        resolve(response.data)
      })
      .catch(async error => {
        console.log(error)
      })
  })
}

async function sendPut (service, url, payload) {
  let key = null
  let params = null
  if (payload != null) {
    key = payload.key
    params = payload.params
  }

  // object 검사
  if (typeof params !== 'object') {
    return false
  }
  // TODO header -> multipart/form-data ?

  if (key !== null && key !== '') {
    const names = Object.keys(key)
    const values = Object.values(key)
    names.forEach((name, index) => {
      url = url.replace('{' + name + '}', values[index])
    })
  }

  return new Promise(resolve => {
    service.put(url, params)
      .then(response => {
        resolve(response.data)
      })
      .catch(async error => {
        console.log(error)
      })
  })
}

async function sendDelete (service, url, payload) {
  let key = null
  let params = null
  if (payload != null) {
    key = payload.key
    params = payload.params
  }

  let lastChar = url.slice(-1)
  url = lastChar === '/' ? url + '?' : url + '/?'

  if (Array.isArray(params)) {
    for (var param of params) {
      let tempString = Object.keys(param) + '=' + Object.values(param) + '&'
      url = url + tempString
    }
  }
  url = url.slice(0, -1)

  if (key !== null && key !== '') {
    const names = Object.keys(key)
    const values = Object.values(key)
    names.forEach((name, index) => {
      url = url.replace('{' + name + '}', values[index])
    })
  }

  return new Promise(resolve => {
    service.delete(url, params)
      .then(response => {
        resolve(response.data)
      })
      .catch(async error => {
        console.log(error)
      })
  })
}
// TODO #12267 - 삼성화재 오류 발생현황 로그 데이터 집계로 인한 에러 이력 적재 (삼성화재 계약 종료시, 삭제예정)
function createErrorTrackHistory (errorPath, errorMessage, status) {
  if (status == 500 && store.getters.clientCd === 'samsungfire') {
    let payload = {
      key: 'param',
      params: {
        errorTypeCode: ERROR_TYPE_CODE,
        errorPath: errorPath,
        errorMessage: errorMessage,
        userKey: store.getters.userKey
      }
    }
    return transmission(true, WEB_METHODS.POST, USER_ROOT+`/error/track-history`, payload)
  }
}


export {
  INNER_ROOT,
  USER_ROOT,
  COMMON_ROOT,
  FILE_ROOT_URL,
  transmission,
  WEB_METHODS
}
